import React from "react";
import console_logo from "../assets/console_logo.png";
import avo_logo from "../assets/avo_logo.png";
import hdtn_logo from "../assets/hdtn_gui.png";
import CheckIcon from "@material-ui/icons/Check";
export const COLUMNS = [
  {
    Header: "ID",
    accessor: "id",
    width: 150,
  },
  {
    Header: "Name",
    accessor: "name",
    width: 150,
    Cell: (cell) =>
      !cell.row.values["edited"] ? (
        cell.mine === true ? (
          <button
            className="name_tag_button"
            value={cell.row.values.inner_nodes}
            onClick={() => {
              cell.row.toggleRowSelected();
              cell.row.values["new_name"] = cell.row.values.name;
              cell.row.values["edited"] = true;
            }}
          >
            <span className="name_tag_span">
              {cell.row.values["new_name"] !== undefined
                ? cell.row.values["new_name"] === ""
                  ? "------"
                  : cell.row.values["new_name"]
                : cell.row.values.name === ""
                ? "------"
                : cell.row.values.name}
            </span>
          </button>
        ) : (
          <button className="name_text_disabled_button">
            <span className="name_tag_span">
              {cell.row.values["new_name"] !== undefined
                ? cell.row.values["new_name"] === ""
                  ? "------"
                  : cell.row.values["new_name"]
                : cell.row.values.name === ""
                ? "------"
                : cell.row.values.name}
            </span>
          </button>
        )
      ) : (
        <span className="name_tag_div">
          <input
            autoFocus
            className="name_tag_input"
            type="text"
            name="name"
            value={cell.row.values["new_name"]}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                if (
                  cell.row.values["changed"] &&
                  cell.row.values["name"] !== cell.row.values["new_name"]
                ) {
                  let new_name = cell.row.values["new_name"];
                  if (new_name === "") {
                    new_name = "------";
                  }
                  cell.update_name(cell.row.values, new_name);
                }
                cell.row.values["edited"] = false;
                cell.row.toggleRowSelected(true);
              }
            }}
            onFocus={() => {
              cell.row.toggleRowSelected(false);
            }}
            onChange={(e) => {
              cell.row.values["new_name"] = e.target.value;
              cell.row.values["changed"] = true;
              cell.row.toggleRowSelected(false);
            }}
            maxLength="30"
          />
          <button
            className="name_submit_button"
            onClick={() => {
              if (
                cell.row.values["changed"] &&
                cell.row.values["name"] !== cell.row.values["new_name"]
              ) {
                let new_name = cell.row.values["new_name"];
                if (new_name === "") {
                  new_name = "------";
                }
                cell.update_name(cell.row.values, new_name);
              }
              cell.row.values["edited"] = false;
              cell.row.toggleRowSelected(true);
            }}
          >
            <CheckIcon className="description_edit_icon"></CheckIcon>
          </button>
        </span>
      ),
  },
  {
    Header: "EID",
    accessor: "eid",
    width: 75,
  },
  {
    Header: "Address",
    accessor: "public_ip",
    width: 150,
    Cell: (cell) =>
      cell.demoMode ? (
        <button disabled={true} className="hidden_table_field">
          {" "}
          ------------{" "}
        </button>
      ) : (
        cell.row.values.public_ip
      ),
  },
  {
    Header: "Port",
    accessor: "port",
    width: 100,
    Cell: (cell) =>
      cell.demoMode ? (
        <button disabled={true} className="hidden_table_field">
          {" "}
          ----{" "}
        </button>
      ) : (
        cell.row.values.port
      ),
  },
  {
    Header: "CL",
    accessor: "convergence_layer",
    width: 75,
  },
  {
    Header: "Impl.",
    accessor: "implementation",
    width: 75,
  },
  {
    Header: "Creator",
    accessor: "owner",
    width: 150,
    Cell: (cell) =>
      cell.demoMode ? (
        cell.mine ? (
          <span style={{ whiteSpace: "nowrap" }}>{"spatiam-user"}</span>
        ) : (
          <button disabled={true} className="hidden_table_field">
            {" "}
            -------{" "}
          </button>
        )
      ) : (
        <span style={{ whiteSpace: "nowrap" }}>{cell.row.values.owner}</span>
      ),
  },
  {
    Header: "Parent",
    accessor: "parent_node",
    show: false,
    width: 150,
  },
  {
    Header: "Network",
    accessor: "network",
    show: false,
    width: 150,
  },
  {
    Header: "UUID",
    accessor: "uuid",
    show: false,
    width: 150,
  },
  {
    Header: "AMI_state",
    accessor: "ami_state",
    show: false,
    width: 150,
  },
  {
    Header: "",
    accessor: "inner_nodes",
    width: 90,
    Cell: ({ cell }) =>
      cell.row.values.inner_nodes.length > 0 ? (
        <a
          href={
            (cell.row.values.parent_node ? "../" : "") +
            cell.row.values.eid +
            "/"
          }
        >
          <button
            className="gateway_button"
            value={cell.row.values.inner_nodes}
          >
            View Gateway
          </button>
        </a>
      ) : null,
  },
  {
    Header: "",
    accessor: "ami_enabled",
    width: 50,
    Cell: (cell) =>
      cell.row.values.ami_enabled === true ? (
        <div className="toolti_left" style={{ padding: "0" }}>
          <button
            className={
              cell.row.values.ami_state === "running"
                ? "console_button enabled"
                : "console_button disabled"
            }
            onClick={() => {
              if (cell.row.values.ami_state === "running") {
                cell.row.toggleRowSelected();
                cell.access_console(cell.row.values.uuid);
              }
            }}
          >
            <img className="console_logo" src={console_logo} alt="logo" />
            <span className="tooltitext">
              {"  "}
              {cell.row.values.ami_state === "running"
                ? "Running - Open DTN Console"
                : cell.row.values.ami_state === "failed"
                ? "Failed - Node Unavailable"
                : "Pending - Initializing Node"}
              {"  "}
            </span>
          </button>
          <span
            className={
              cell.row.values.ami_state === "running"
                ? "status_dot running"
                : cell.row.values.ami_state === "failed"
                ? "status_dot failed"
                : "status_dot pending"
            }
          ></span>
        </div>
      ) : null,
  },
  {
    Header: "",
    accessor: "hdtn_interface",
    width: 50,
    Cell: ({ cell }) =>
      cell.row.values.implementation === "HDTN" &&
      cell.row.values.ami_enabled === true ? (
        <div className="toolti_left" style={{ padding: "0" }}>
          <button
            className={"hdtn_gui_button"}
            onClick={() => {
              if (cell.row.values.ami_state === "running") {
                cell.row.toggleRowSelected();
                let url = "http://" + cell.row.values.public_ip + ":8086/web_gui.html";
                const win = window.open(url, "_blank");
                if (win != null) {
                  win.focus();
                }
              }
            }}
          >
            <img className="console_logo" src={hdtn_logo} alt="logo" />
            <span className="tooltitext">Access HDTN Interface</span>
          </button>
          <span
            className={
              cell.row.values.ami_state === "running"
                ? "status_dot running"
                : cell.row.values.ami_state === "failed"
                ? "status_dot failed"
                : "status_dot pending"
            }
          ></span>
        </div>
      ) : null,
  },
  {
    Header: "",
    accessor: "is_avocado",
    width: 50,
    Cell: ({ cell }) =>
      cell.row.values.is_avocado === true ? (
        <div className="toolti_left" style={{ padding: "0" }}>
          <button
            className={"avocado_button"}
            onClick={() => {
              cell.row.toggleRowSelected();
              let url = "https://www.spatiam.com/avocado-phone/";
              const win = window.open(url, "_blank");
              if (win != null) {
                win.focus();
              }
            }}
          >
            <img className="console_logo" src={avo_logo} alt="logo" />
            <span className="tooltitext">Access Avocado Phone</span>
          </button>
          <span className={"status_dot running"}></span>
        </div>
      ) : null,
  },
];
